function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCeloLogo = function SvgCeloLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 1250,
    cy: 1250,
    r: 1250,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fcff52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.3 546.2H550.7v1407.7h1398.7v-491.4h-232.1c-80 179.3-260.1 304.1-466.2 304.1-284.1 0-514.2-233.6-514.2-517.5 0-284 230.1-515.6 514.2-515.6 210.1 0 390.2 128.9 470.2 312.1h228.1V546.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCeloLogo;